import React from 'react';
import { string } from 'prop-types';

import styles from './ListLabels.scss';

function ListLabels({ sortValue, location }) {
  return (
    <div className={styles.listLabels}>
      <span>trend</span>
      <span>
        {location}
      </span>
      <span>
        {sortValue === 'tti' ? 'tti' : 'live speed'}
      </span>
      <span>last hr</span>
    </div>
  );
}

ListLabels.propTypes = {
  sortValue: string.isRequired,
  location: string.isRequired,
};

export default ListLabels;



// WEBPACK FOOTER //
// ./src/components/DataPanel/Overview/ListLabels/index.js